import { act, useContext, useEffect, useRef, useState } from "react";
import { IconButton, StandardButton } from "../atoms/buttons";


import { LessonComp } from "../components/lessonComp";

import { LessonStepBar } from "../components/lessonStepBar";


import { ScreenNavigation } from "../molecule/screenNavigation";

import { HorizontalLayout, VerticalPageLayout } from "../components/layout";
import { deleteAPI, getAPI, postAPI, updateAPI } from "../api/api";
import { AICourseTitleModal } from "../components/customModals";
import { PageContext } from "../App";
import { Alert } from "../components/alert";
import { set } from "date-fns";
import { icon } from "../functions/icons";
import { Modal, ModalBody, ModalTitle } from "../components/modal";
import { IconText } from "../components/courseComp";
import { IconAtom2, TextIcon } from "../atoms/iconAtom";
import { useFeatures } from "../FeaturesContext";


export function CreateCourse({ pageSwap, courseID, CustomerStage }) {
  const navigationContext = useContext(PageContext)
  const [lessons, setLessons] = useState([{ title: "elearning", duration: "1h", active: false, thumbnail: "test", courseID: 0 }])
  const [activeTitleSearch, setActiveTitleSearch] = useState(false)
  const [activeLessonsIndex, setActiveLessonsIndex] = useState(null)
  const sectionRefs = useRef({})
  const [position, setPositions] = useState({})
  const [fixedSideNav, setFixedSideNav] = useState(false)
  const [rect, setRect] = useState({})
  const [errorMessage, setErrorMessage] = useState("");
  const courseRef = useRef(0)
  const scrollRef = useRef(0)
  const [loading, setLoading] = useState(false);
  const [clickedTwice, setClickedTwice] = useState(false);
  const [skillMessage, setSkillMessage] = useState("");
  const [skills, setSkills] = useState([]);
  const [message, setMessage] = useState("");
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const handleLoading = () => loading ? (setMessage("De AI is bezig met genereren, je kunt de les nog niet sluiten."), setTimeout(() => setMessage(""), 4000), true) : false;
  const addNewLesson = async (title = "") => {
    const query = "api/courses/lessons/create"
    courseRef.current++
    const body = { title: title, duration: "0", active: true, thumbnail: "", id_course: navigationContext.sidebar.courseID, courseID: courseRef.current, indexed:maxIndex(lessons) }

    const addLesson = await postAPI(query, body)
    if (addLesson.status === "ok") {
      body.id_lessons = addLesson.data
      const newCourses = [...lessons, body]
      setLessons([...newCourses])
      setAnimationState(lessons.length, "create");
      setTimeout(() => {
        setAnimationState(lessons.length, "");
      }, 405);
    }
  }
  const maxIndex = (lessons) => {
    var max = 0
    lessons.forEach((lesson => { if(max < lesson.indexed){ max = lesson.indexed}}))
    return max + 1
  }

  const loadSkills = async () => {
    const query = `api/courses/lessons/modules/skills/${navigationContext.sidebar.courseID}`;
    const res = await getAPI(query);
    if (res.data) {
      setSkills(res.data)
    } else {
      return []
    }
  }

  useEffect(() => {
    loadLessons()
    loadSkills()
  }, [])

  const loadLessons = async () => {
    const query = `api/courses/lessons/${navigationContext.sidebar.courseID}`
    const load = await getAPI(query)
    if (load.data.length > 0) {
      setLessons(load.data)
      return
    }
    setLessons([])
  }

  const finishLesson = (skills) => {
    console.log("Checking skills coverage:", skills);
    const notTestedSkills = checkSkillsCoverage(skills);
    if (notTestedSkills.length > 0) {
      const skillNames = notTestedSkills.map(s => s.skillName).join(", ");

      if (!clickedTwice) {
        setSkillMessage(`Deze skills zijn nog niet getest: <strong>${skillNames}</strong>. Je kunt ze toevoegen aan een quiz voor extra oefening.`);
        setClickedTwice(true);
        setTimeout(() => setClickedTwice(false), 60000);
        return;
      }
    }

    const incompleteLessons = lessons.filter(lesson => !lesson.title || !lesson.description);
    if (incompleteLessons.length === 0) {
      setErrorMessage("Fout: Er zijn geen lessen gemaakt.");
      return;
    }
    setSkillMessage("");
    setClickedTwice(false);
    navigationContext.handleNavigation({ ...navigationContext.sidebar, navigation: CustomerStage == 5 ? 702 : 7 })
  }

  const setAnimationState = (index, state) => {
    setLessons((prev) =>
      prev.map((lesson, i) =>
        i === index ? { ...lesson, animationState: state } : lesson
      )
    );
  };

  const removeCourse = (lesson, index) => {
    setAnimationState(index, "remove");
    setTimeout(() => {
      const copyCourses = [...lessons]
      copyCourses.splice(index, 1)
      setLessons(copyCourses);
      deleteAPI("api/courses/lessons/remove", { ...lesson });


    }, 405);
  };
  function checkSkillsCoverage(skills) {
    const skillMap = {};
    skills.forEach(skill => {
      const skillId = skill.id_skill;
      const isQuizModule = skill.id_type === 1;
      if (!skillMap[skillId]) {
        skillMap[skillId] = {
          connectedToModule: true,
          testedInQuiz: false,
          skillName: skill.skill_name,
        };
      }
      if (isQuizModule) {
        skillMap[skillId].testedInQuiz = true;
      }
    });
    const notTestedSkills = Object.values(skillMap).filter(s => s.connectedToModule && !s.testedInQuiz);
    return notTestedSkills;
  }
  const activateLesson = (index, event) => {
    if (handleLoading()) return;
    setLessons(prevLessons =>
      prevLessons.map((lesson, i) => ({
        ...lesson,
        active: i === index ? !lesson.active : false,
      }))
    );
  }
  const handleInput = async (text, index) => {
    const copyCourses = [...lessons]
    copyCourses[index].title = text
    setLessons(copyCourses)
    const updatedLesson = copyCourses[index];
    const query = "api/courses/lessons/update";
    const body = {
      "id_lessons": updatedLesson.id_lessons,
      "title": updatedLesson.title,
      "id_course": updatedLesson.id_course
    };
    await updateAPI(query, body);
  }


  const changeIndexLesson = (index) => {
    if (activeLessonsIndex === null) {
      setActiveLessonsIndex(index);
      const copy_lessons = [...lessons]
      copy_lessons[index].update_lesson_index = true
      setLessons(copy_lessons)
      return;
    }
  
    const copy_lessons = [...lessons];
    const index1 = copy_lessons[activeLessonsIndex].indexed
    const index2 = copy_lessons[index].indexed
    const copy_lessons_second = [...lessons]
    copy_lessons[activeLessonsIndex] = copy_lessons[index];

    copy_lessons[index].update_lesson_index = true
    copy_lessons[index] = copy_lessons_second[activeLessonsIndex];
  

    copy_lessons[index].indexed = index2
    copy_lessons[activeLessonsIndex].indexed = index1

    const indexed_lessons = [copy_lessons[index], copy_lessons[activeLessonsIndex]]
    console.log([...indexed_lessons])
    updateLessonIndex([...indexed_lessons])
    setActiveLessonsIndex(null);
    setTimeout(() => {
      setLessons(copy_lessons);
    }, 500)

    setTimeout(() => {
      copy_lessons.map(lesson => lesson.update_lesson_index = false)

      setLessons([...copy_lessons])

    }, 1000)
  
  }
  const updateLessonIndex = async (indexed_lessons) => {
    const query = 'api/courses/lessons/update-order'
    const body = [...indexed_lessons]
     await updateAPI(query, body)

  }

  const changePos = (ref) => {
    const comp = ref.current.getBoundingClientRect();
    const noValidLessons = lessons.length < 2;

    if (noValidLessons) {
      setPositions({ x: comp.x, y: comp.y + comp.height + 35, width: 380 });
    } else {
      setPositions({ x: comp.x, y: comp.y - 345, width: 380 });
    }

    setActiveTitleSearch(true);
  };

  const handleDeleteConfirmation = () => {
    setDeleteModalVisible(true);
  };

  const deleteCourse = async () => {
    const query = 'api/courses/delete';
    const body = { id_course: navigationContext.sidebar.courseID };
    const res = await updateAPI(query, body)
    if (res.status === 'ok') {
      navigationContext.handleNavigation({ courseID: 0, navigation: CustomerStage === 5 ? 402 : 2, enrollment: 0 });
    } else
      setErrorMessage("Verwijder van cursus mislukt!")
  }

  const handleScrollData = (data) => {
    scrollRef.current = data
    if (scrollRef.current > 86) {
      setFixedSideNav(true)
      return
    }
    setFixedSideNav(false)
  }

  return (
    <VerticalPageLayout scrollData={(value) => handleScrollData(value)} className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
      <div className="vertical standard-padding" style={{ width: "unset" }}>
        <HorizontalLayout className="space-between">
          <ScreenNavigation goBack={() => navigationContext.handleNavigation({ courseID: 0, navigation: CustomerStage === 5 ? 402 : navigationContext.sidebar?.back_page, enrollment: 0 })} title={"Maak cursus"} />
          <StandardButton size="small" title={"Cursus verwijderen"} backgroundColor="transparent" textColor={"standard-text-color-light"} deleteIcon={true} onClick={handleDeleteConfirmation} />
        </HorizontalLayout>

        <div className="horizontal" style={{ alignItems: "unset", position: "relative" }}>
          <div className="vertical phone-side-content right-side-content standard-padding heavy-border standard-rounded card-background-color" style={{ width: "35%", height: "max-content", marginRight: "0.75rem", position: (fixedSideNav) ? "sticky" : "", top: (fixedSideNav) ? "0.2rem" : "" }}>
            {lessons.map((lesson, index) => {
              return (
                <LessonComp
                  changeIndex={() => changeIndexLesson(index)}
                  message={index === 0 ? message : ""}
                  setLoading={setLoading}
                  handleLoading={handleLoading}
                  loading={loading}

                  lessonData={lesson}
                  key={index}
                  navigation={true}
                  onClick={(event) => activateLesson(index, event)}
                />
              )
            })}

          </div>

          <div className="phone-lesson vertical card-background-color standard-padding standard-rounded heavy-border">
            <LessonStepBar
              activeStep={2}
            />
            {lessons.map((lesson, index) => {
              const filteredSkills = skills.filter(skill => skill.id_lessons === lesson.id_lessons);
              return (
                <LessonComp
                  message={index === 0 ? message : ""}
                  setLoading={setLoading}
                  handleLoading={handleLoading}
                  loading={loading}
                  key={index}
                  sectionRefs={sectionRefs}
                  lessonData={lesson}
                  typeInput={(text) => handleInput(text, index)}
                  onClick={(event) => activateLesson(index, event)}
                  remove={() => removeCourse(lesson, index)}
                  animationState={lesson.animationState}
                  skills={filteredSkills}
                  
                  allSkills={skills}
                  loadSkills={loadSkills}
                  setSkills={setSkills}
                  changeIndex={() => changeIndexLesson(index)}
                />
              )
            })}
            <AddLesson
              changePos={changePos}
              addNewLesson={() => addNewLesson()}
            />
            <AICourseTitleModal
              addTitle={(value) => { addNewLesson(value.lesson_title); setActiveTitleSearch(!activeTitleSearch) }}
              rect={(value) => setRect(value)}
              course={courseID}
              dismiss={() => setActiveTitleSearch(!activeTitleSearch)}
              position={position}
              visible={activeTitleSearch}

            />
            {errorMessage && <Alert className={"error-button standard-margin-top"} type="error" message={errorMessage} />}
            {skillMessage && (<Alert dismissable={() => setSkillMessage("")} className="standard-margin-top" title={"Tip!"} type="warning" message={<span dangerouslySetInnerHTML={{ __html: skillMessage }} />} />)}
            <HorizontalLayout className="phone-publiceren" style={{ marginLeft: "auto", marginTop: '1rem', width: "auto", }}>
              <StandardButton
                onClick={() => finishLesson(skills)}
                title={"Ga naar les publiceren"}
                arrow="right"
                color={"semi-bold"}

              />
            </HorizontalLayout>

          </div>

        </div>
      </div>
      <DeleteCourseModal
        setDeleteModalVisible={setDeleteModalVisible}
        visible={deleteModalVisible}
        deleteCourse={deleteCourse}
      />
    </VerticalPageLayout>
  )
}

function AddLesson({ addNewLesson, aiClick, position, changePos }) {
  const ref = useRef(null)
  const handleAiClick = () => {
    changePos(ref);

  }
  const { isFeatureEnabled } = useFeatures();

  return (
    <HorizontalLayout>
      <div className="file-container" onClick={addNewLesson}>
        <p className="standard-text semi-bold primary-600 small-standard-padding">+ Maak nieuwe les</p>
      </div>

      {isFeatureEnabled(13) && <IconButton ref={ref} onClick={handleAiClick} iconButton={false} icon2={"wand"} className={"file-container primary-600 icon-button-standard icon xl-size standard-margin-left "} size={"1.4rem"} />}

    </HorizontalLayout>
  );
}


export function DeleteCourseModal({ setDeleteModalVisible, visible, deleteCourse }) {
  return (
    <Modal
      dismissable={() => setDeleteModalVisible(false)}
      visible={visible}
      size="small"
      content={
        <>
          <ModalTitle
            dismissable={() => setDeleteModalVisible(false)}
            hasXmark={true}
            title="Cursus verwijderen"
          />
          <ModalBody
            style={{ maxWidth: "400px" }}
            content={
              <>
                <p className="standard-margin-bottom">
                  Weet u zeker dat u deze cursus wilt verwijderen?
                  Alle gegevens zullen verloren gaan.
                  Deze actie kan niet ongedaan worden gemaakt.
                </p>
                <HorizontalLayout
                  style={{ justifyContent: "flex-end", gap: "1rem" }}
                >
                  <StandardButton
                    className="secondary-button"
                    title="Nee, toch niet"
                    onClick={() => setDeleteModalVisible(false)}
                  />
                  <StandardButton
                    backgroundColor="error-600"
                    title="Ja, verwijder"
                    onClick={async () => {
                      await deleteCourse();
                      setDeleteModalVisible(false);
                    }}
                  />
                </HorizontalLayout>
              </>
            }
          />
        </>
      }
    />
  );
}
